<template>
  <div id="app">
    <v-app>
      <v-container fluid grid-list-lg text-xs-center class>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card elevation="0" color="#fff7dc" style="border: 2px dashed #6fdcff; text-align: left">
              <v-card-title primary-title>
                <div>
                  <span class="headline" style="color: #18739d"><b>Self Generated Risky Images</b></span>
                  <div class="subheading" style="font-size: 17px !important">
                    40-50% of the cases of child sexual abuse seen by the
                    <a href="https://www.iwf.org.uk/" target="_blank">IWF</a> involve images which are self generated.
                    Privately’s technology is able to analyse imagery BOTH for NUDITY and AGE. This technology can be
                    very simply integrated as an SDK into apps, games and devices to warn children in real-time. With
                    our large trials using nudge techniques we have been able to show that about 25% of all children
                    will immediately heed to real-time warnings. This technology has potential to cut down
                    self-generated imagery significantly and PREVENT possibly many cases of CSE from occuring.
                    <a href="https://youtube.com/shorts/GFnysaO60Hg" target="_blank"
                      >https://youtube.com/shorts/GFnysaO60Hg</a
                    >. For more information on how we process data, please refer to
                    <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 lg5 md5 sm6
            ><v-tabs
              centered
              :icons-and-text="
                $vuetify.breakpoint.name != 'lg' && $vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'md'
              "
              color="#18739d"
              dark
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#tab-1" @click="clearUrl">
                Gallery
                <v-icon>image</v-icon>
              </v-tab>

              <v-tab href="#tab-2" @click="clearUrl">
                Upload
                <v-icon>upload</v-icon>
              </v-tab>

              <v-tab-item :key="1" value="tab-1">
                <v-card>
                  <div id="overlay" v-if="loading"></div>

                  <v-container grid-list-sm fluid>
                    <v-layout row wrap
                      ><v-flex v-for="(item, index) in dataImages" :key="index" xs4>
                        <v-hover>
                          <v-card
                            flat
                            :width="width + 'px'"
                            :height="height + 'px'"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 10 : 0}`"
                          >
                            <img
                              :width="width"
                              :height="height"
                              style="object-fit: cover"
                              :id="item.id"
                              :src="item.src"
                              class="galleryImg"
                              :class="item.id == selectedItemId ? 'selected' : ''"
                              @click="onSelectImage(item, $event)"
                            />
                          </v-card>
                        </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2" value="tab-2">
                <v-card flat>
                  <div v-if="!file">
                    <div
                      :class="['dropZone', dragging ? 'dropZone-over' : '']"
                      @dragenter="dragging = true"
                      @dragleave="dragging = false"
                    >
                      <div class="dropZone-info" @drag="onChange">
                        <span class="fa fa-cloud-upload dropZone-title"></span>
                        <v-icon>upload</v-icon>
                        <span class="dropZone-title">Drop file or click to upload</span>
                        <div class="dropZone-upload-limit-info">
                          <div>maximum file size: 5 MB</div>
                        </div>
                      </div>
                      <input type="file" @change="onChange" />
                    </div>
                  </div>
                  <div v-else class="dropZone-uploaded">
                    <div class="dropZone-uploaded-info">
                      <span class="dropZone-title">Uploaded {{ file.name }}</span>

                      <v-btn text link flat class="removeFile" @click="removeFile"> Upload another </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs></v-flex
          >
          <v-flex xs12 lg5 md5 sm6>
            <v-toolbar color="#18739d" dark>
              <v-toolbar-title>Analysis Result</v-toolbar-title> <v-icon>poll</v-icon>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card class="d-flex align-center justify-center mb-6">
              <v-container bg fill-height grid-list-md text-xs-center>
                <v-layout row wrap align-center>
                  <v-flex xs12 v-if="hasError && !loading">
                    <v-alert value="true" color="red" outline type="error">
                      <b>Problem retrieving the url</b> <br />Try uploading the image instead. If it doesn't work,
                      please try another image.</v-alert
                    >
                  </v-flex>

                  <v-flex xs12 v-if="(selectedSrc == null || selectedSrc == '') && !hasError">
                    <div class="title">Please select or upload an image or paste url</div>
                  </v-flex>
                  <v-flex xs12 v-show="selectedSrc != null && selectedSrc != '' && !hasError">
                    <v-avatar v-show="selectedSrc != null && selectedSrc != ''" size="200" color="grey lighten-4">
                      <img style="object-fit: cover" id="selectedImg" :src="selectedSrc"
                    /></v-avatar>
                    <div v-if="!loading">
                      <br />

                      <div v-if="isRisky != null && !hasError && !loading">
                        <v-chip style="font-size: 18px" :color="!isRisky ? 'green' : 'red'" text-color="white">
                          <v-avatar>
                            <v-icon class="white--text">{{
                              !isRisky ? "check_circle_outline" : "cancel"
                            }}</v-icon> </v-avatar
                          ><b>{{ !isRisky ? "safe" : "risky" }}</b> &nbsp;image
                        </v-chip>

                        <div v-if="isRisky && childDetected != null">
                          <v-chip
                            style="font-size: 18px"
                            :color="childDetected ? '#eed202' : '#18739d'"
                            text-color="white"
                          >
                            {{ childDetected ? "" : "no" }} child detected</v-chip
                          >
                        </div>
                        <div v-if="noFaceDetected">
                          <v-chip color="teal" class="white--text" style="font-size: 18px"> no face detected </v-chip>
                        </div>

                        <div v-if="isRisky && ageNotReliablyDetected">
                          <v-chip class="white--text" style="font-size: 15px" color="#FA8100"
                            >age could not be reliably detected</v-chip
                          >
                        </div>
                      </div>
                    </div>
                    <div v-else><br /><v-progress-circular indeterminate color="primary"></v-progress-circular></div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs12 lg2 md2 sm12>
            <v-card color="transparent" elevation="0">
              <v-card-content primary-title>
                <h3 class="" style="color: #18739d">
                  <span class="headline"
                    >Are you a developer who wants to prevent CSAM generation on your game or app?</span
                  >
                  <br /><span style="font-size: 50px">&#8681;</span><br />

                  <v-btn
                    :block="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'"
                    href="mailto:dev_channel_contact@privately.eu"
                    target="_blank"
                    color="#18739d"
                    class="white--text title"
                    style="text-transform: unset !important"
                  >
                    Contact us for a trial
                  </v-btn>
                </h3>
                <div></div>
              </v-card-content>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap></v-layout>
      </v-container>
      <v-footer height="auto" color="#18739d ">
        <v-layout justify-center row wrap>
          <v-flex lighten-2 py-3 text-xs-center white--text xs12>
            &copy; Copyright 2022 Privately - All Rights Reserved
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
  </div>
</template>




<script>
import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

export default {
  methods: {
    async onPaste(evt) {
      this.hasError = false;
      try {
        this.pastedUrl = evt.clipboardData.getData("text/plain");
        if (this.checkImageURL(this.pastedUrl)) {
          let imgElm = document.getElementById("selectedImg");
          this.selectedSrc = this.pastedUrl;
          imgElm.style.display = "block";
          await this.loadImage(this.pastedUrl, imgElm);

          if (imgElm.complete) {
            let base64 = this.getBase64Image(imgElm);
            this.estimateAgeWithBase64(base64);
            this.estimateRisk(null, this.pastedUrl, false);
            this.hasError = false;
          }
        } else {
          this.selectedSrc = "";
          this.hasError = true;
          return;
        }
      } catch (err) {
        this.loading = false;
        this.hasError = true;
      }
    },
    clearUrl() {
      this.hasError = false;
      this.pastedUrl = "";
      this.pastedUrlText = "";
    },
    onSelectImage: function (data, event) {
      if (this.loading) {
        event.stopPropagation();
        return;
      }
      this.selectedItemId = data.id;
      this.file = "";
      this.imageSelected = data;
      this.selectedSrc = data.src || "";

      let base64 = this.getBase64Image(document.getElementById(data.id));

      this.estimateAgeWithBase64(base64);
      this.estimateRisk(null, data.src, true);
    },

    async loadImage(url, elem) {
      return new Promise((resolve, reject) => {
        elem.onload = () => resolve(elem);
        elem.crossOrigin = "Anonymous";
        elem.onerror = reject;
        elem.src = url;
      });
    },

    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.createFile(files[0]);
    },
    async estimateRisk(file, url, isGallerySrc) {
      this.loading = true;

      let params = {
        url: isGallerySrc ? "https://showroom.privately.swiss" + url : url,
      };
      let base64File = "";

      if (url == null) {
        base64File = await this.getBase64(file).catch((err) => {
          console.log(err);
        });
      }

      let payload = JSON.stringify({ image_data: base64File });

      return axios
        .post("https://showroom.privately.swiss:8081/showroom/nudity4c", url == null ? payload : params, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data) {
            this.isRisky = response.data.predicted_class != "plain";
          } else {
            this.isRisky = null;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("There was an error!", error);
        });
    },
    async estimateRiskWithFile(file) {
      this.getBase64(file).then((data) => {
        // let cleanStr = "data:image/jpeg;base64,";
        // data = data.replace(cleanStr, "");
        return this.estimateRiskWithBase64(file == null ? base64 : data);
      });
    },
    estimateRiskWithBase64(base64) {
      this.loading = true;
      let payload = { image_data: base64 };

      return axios
        .post("https://showroom.privately.swiss:8082/showroom/nudity4c", JSON.stringify(payload), {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data) {
            this.isRisky = response.data.predicted_class != "plain";
          } else {
            this.isRisky = null;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("There was an error !", error);
        });
    },
    async estimateAgeWithBase64(base64) {
      let cleanStr = "data:image/jpeg;base64,";
      base64 = base64.replace(cleanStr, "");
      let payload = { image_data: base64 };
      return this.estimateAge(payload);
    },
    async estimateAgeWithFile(file) {
      this.getBase64(file).then((data) => {
        let payload = { image_data: data };
        return this.estimateAge(payload);
      });
    },
    estimateAge(payload) {
      this.loading = true;
      this.childDetected = null;
      this.noFaceDetected = false;
      this.ageNotReliablyDetected = false;
      return axios
        .post("https://fallback-server-for-on-browser.privately.swiss/margin/image-age-estimation", JSON.stringify(payload), {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data) {
            this.childDetected = response.data.ages.some((age) => age < 18.0);

            if (response.data.error) {
              this.noFaceDetected = response.data.error.code == "no_face_detected";
              this.ageNotReliablyDetected = response.data.error.code != "no_face_detected";
            }
          } else {
            this.childDetected = null;
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.error("There was an error while estimating age!", error);
        });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      // return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
      return dataURL;
    },

    createFile(file) {
      if (!file.type.match("image/jpeg") && !file.type.match("image/png")) {
        alert("please select a JPEG or PNG image file");
        this.dragging = false;
        return;
      }

      if (file.size > 5000000) {
        alert("please check file size no over 5 MB.");
        this.dragging = false;
        return;
      }

      this.file = file;
      this.estimateRisk(this.file, null, null);
      this.estimateAgeWithFile(this.file);

      this.selectedSrc = URL.createObjectURL(this.file);
      this.dragging = false;
    },
    removeFile() {
      this.file = "";
    },
    checkImageURL(url) {
      return url.match(/^https?:\/\/.+\/.+$/);
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
  computed: {
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 88;
        case "sm":
          return 88;
        case "md":
          return 88;
        case "lg":
          return 140;
        case "xl":
          return 200;
      }
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 88;
        case "sm":
          return 88;
        case "md":
          return 88;
        case "lg":
          return 140;
        case "xl":
          return 200;
      }
    },
  },
  data: () => ({
    analysisResult: "",
    childDetected: null,
    spoofDetected: false,
    selectedItemId: "",
    dataImages: [
      {
        id: "1",
        src: require("@/assets/images/gallery/img_1.jpeg"),
        alt: "Alt Image 1",
      },
      {
        id: "2",
        src: require("@/assets/images/gallery/img_2.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "3",
        src: require("@/assets/images/gallery/img_3.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "4",
        src: require("@/assets/images/gallery/img_4.jpeg"),
        alt: "Alt Image 1",
      },
      {
        id: "5",
        src: require("@/assets/images/gallery/img_5.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "6",
        src: require("@/assets/images/gallery/img_6.jpeg"),
        alt: "Alt Img",
      },
      {
        id: "7",
        src: require("@/assets/images/gallery/img_7.jpeg"),
        alt: "Alt imggg",
      },
      {
        id: "8",
        src: require("@/assets/images/gallery/img_8.jpeg"),
        alt: "Alt imggg",
      },
      {
        id: "9",
        src: require("@/assets/images/gallery/img_9.jpeg"),
        alt: "Alt imggg",
      },
    ],
    file: "",
    pastedUrl: "",
    noFaceDetected: false,
    ageNotReliablyDetected: false,
    pastedUrlText: "",
    base64img: "",
    loading: false,
    imageSelected: "",
    isRisky: null,
    hasError: false,
    classes: [
      { key: "nsfw", name: "NSFW", emoji: "👔" },
      { key: "sexy_selfie", name: "Sexy Selfie", emoji: "🤳🏻" },
      { key: "bikini", name: "Bikini", emoji: "👙" },
      { key: "clean", name: "Clean", emoji: "✅" },
    ],
    containsChild: "",
    selectedSrc: null,
    dragging: false,
  }),
};
</script>

<style>
#overlay {
  position: absolute;
  display: grid;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
}

.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975a0;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

@media only screen and (hover: none) and (pointer: coarse) {
  .galleryImg img {
    width: 33px !important;
    height: 33px !important;
  }

  #selectedImg {
    width: 200px;
    height: 200px;
  }
}

.removeFile {
  width: 200px;
}

.selected {
  border: 5px solid #6fdcff !important;
}
</style>
